import React, { useEffect, useState } from 'react'
import { api } from '../../services'
import { Card, Spin, Icon, Typography, Row, Col, Tag, Button, message, Modal, Form, Input, InputNumber } from 'antd'
import history from '../../history'
import './quest.scss'
import LocationPickerModal from './components/LocationPickerModal'
import { connect } from 'react-redux'

const { Title, Text, Paragraph } = Typography

const ViewQuestStop = ({ user }) => {
    const [locationData, setLocationData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [isLocationModalVisible, setIsLocationModalVisible] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)
    const [editModalVisible, setEditModalVisible] = useState(false)
    const [isSavingStop, setIsSavingStop] = useState(false)
    const [huntId, setHuntId] = useState(null)
    const [editFormData, setEditFormData] = useState({
        story: '',
        objective: '',
        fun_fact: '',
        open_ended: '',
        points: 0,
        points_mc: 0,
        points_open_ended: 0
    })
    const { active_organization_id, id: user_id } = user?.info


    const searchParams = new URLSearchParams(window.location.search)
    const location_id = searchParams.get('location_id')
    const stop_index = searchParams.get('stop_index')

    useEffect(() => {
        if (location_id) {
            getSpecificLocation(location_id)
        } else {
            setIsLoading(false)
        }
    }, [location_id])

    const getSpecificLocation = async (id) => {
        try {
            setIsLoading(true)
            const res = await api.quest.getSpecificLocation(id)
            if (res && res.data) {
                setHuntId(res.data.treasure_hunt_id)
                setLocationData(res.data)
            }
        } catch (error) {
            console.error('Error fetching location:', error)
        } finally {
            setIsLoading(false)
        }
    }

    const handleLocationSelect = async (selectedLocation) => {
        try {
            setIsUpdating(true)
            const payload = {
                stops: [
                    {
                        stop_number: parseInt(stop_index),
                        coordinates: `${selectedLocation.lat}, ${selectedLocation.lng}`,
                        name: selectedLocation.town || selectedLocation.full,
                        address: selectedLocation.full,
                    }
                ]
            }
            const res = await api.quest.updateSpecificLocation(location_id, payload)
            if (res && res.data) {
                message.success('Location updated successfully')
                // Re-fetch to update UI
                const updatedRes = await api.quest.getSpecificLocation(location_id)
                if (updatedRes && updatedRes.data) {
                    setLocationData(updatedRes.data)
                }
            }
        } catch (error) {
            console.error('Error updating location:', error)
            message.error('Failed to update location')
        } finally {
            setIsUpdating(false)
            setIsLocationModalVisible(false)
        }
    }

    const handleEditStop = (stop) => {
        setEditFormData({
            story: stop.story || '',
            objective: stop.objective || '',
            fun_fact: stop.fun_fact || '',
            open_ended: stop.quiz?.open_ended || '',
            points: stop.points || 0,
            points_mc: stop.points_mc || 0,
            points_open_ended: stop.points_open_ended || 0,
        })
        setEditModalVisible(true)
    }
    const performUpdate = async () => {
        setIsSavingStop(true)
        try {
            const payload = {
                stops: [
                    {
                        stop_number: stop_index,
                        story: editFormData.story,
                        objective: editFormData.objective,
                        fun_fact: editFormData.fun_fact,
                        points: editFormData.points,
                        points_mc: editFormData.points_mc,
                        points_open_ended: editFormData.points_open_ended,
                    }
                ]
            }

            const params = { user_id, org_id: active_organization_id }
            const res = await api.quest.updateQuest(huntId, params, payload)
            if (res && res.status === 200) {
                message.success('Quest stop updated successfully')
                setEditModalVisible(false)
                getSpecificLocation(location_id)
            } else {
                message.error('Failed to update quest stop')
            }
        } catch (error) {
            console.error('Error updating quest stop:', error)
            message.error('An error occurred while updating quest stop')
        } finally {
            setIsSavingStop(false)
        }
    }

    const handleRegenerateQuiz = async () => {
        try {
            setIsLoading(true)
            const params = { user_id, org_id: active_organization_id }
            const res = await api.quest.regenerateQuiz(huntId, stop_index, params)
            if (res && res.status === 200 && res.data?.stop?.quiz) {
                message.success('Quiz regenerated successfully')
                // Re-fetch to update UI
                const updatedRes = await api.quest.getSpecificLocation(location_id)
                if (updatedRes && updatedRes.data) {
                    setLocationData(updatedRes.data)
                }
            } else {
                message.error('Failed to regenerate quiz')
            }
        } catch (error) {
            console.error('Error regenerating quiz:', error)
            message.error('An error occurred while regenerating quiz')
        } finally {
            setIsLoading(false)
        }
    }

    const isEditDisabled = (editFormData.points || 0) === ((editFormData.points_mc || 0) + (editFormData.points_open_ended || 0));

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f5f7fa' }}>
                <Spin size="large" tip="Loading Quest Stop..." />
            </div>
        )
    }

    if (!locationData) {
        return (
            <div style={{ padding: '50px', textAlign: 'center' }}>
                <Icon type="frown" style={{ fontSize: 64, color: '#bfbfbf', marginBottom: 20 }} />
                <Title level={3}>Location Not Found</Title>
                <Button type="primary" onClick={() => history.goBack()}>Go Back</Button>
            </div>
        )
    }

    const { stops } = locationData
    const currentStop = stops && stop_index ? stops.find(s => s.stop_number === parseInt(stop_index)) : null

    if (!currentStop) {
        return (
            <div style={{ padding: '50px', textAlign: 'center' }}>
                <Icon type="warning" style={{ fontSize: 64, color: '#faad14', marginBottom: 20 }} />
                <Title level={3}>Treasure Hunt Stop {stop_index} Not Found</Title>
                <Button type="primary" onClick={() => history.goBack()}>Go Back</Button>
            </div>
        )
    }

    return (
        <div className="view-quest-stop-container" style={{ padding: '24px', background: '#f5f7fa', minHeight: '100vh' }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                    <Button
                        icon="left"
                        onClick={() => history.goBack()}
                        style={{ borderRadius: '20px', border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
                    >
                        Back
                    </Button>
                    <div>
                        <Tag color="#1890ff" style={{ fontSize: '14px', padding: '4px 12px', borderRadius: '4px' }}>
                            Treasure Hunt Stop #{currentStop.stop_number}
                        </Tag>
                        <Tag color="gold" style={{ fontSize: '14px', padding: '4px 12px', borderRadius: '4px' }}>
                            {currentStop.points || 0} PTS
                        </Tag>
                    </div>
                </div>

                <div className="accordion__item" style={{ opacity: 1, padding: 0 }}>
                    <div className="accordion__header active" style={{ cursor: 'default' }}>
                        <div className="accordion__title" style={{ fontSize: '20px' }}>
                            {currentStop.title}
                        </div>
                    </div>

                    <div className="accordion__content corporate-style">
                        <div className="accordion__section">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h4 className="corporate-label">Mission Narrative</h4>
                                <Button
                                    type="link"
                                    size="small"
                                    icon="edit"
                                    onClick={() => handleEditStop(currentStop)}
                                >
                                    Edit
                                </Button>
                            </div>
                            <p className="corporate-text">{currentStop.story}</p>
                        </div>
                        <div className="accordion__section">
                            <h4 className="corporate-label">Mission Objective</h4>
                            <p className="corporate-text">{currentStop.objective}</p>
                        </div>


                        <div className="accordion__grid">
                            <div className="accordion__section">
                                <h4 className="corporate-label">Fun Fact</h4>
                                <div className="corporate-insight">
                                    <Icon type="bulb" style={{ color: '#faad14', marginRight: 8 }} />
                                    {currentStop.fun_fact}
                                </div>
                            </div>
                            <div className="accordion__section">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                    <h4 className="corporate-label" style={{ margin: 0 }}>Open Ended Question</h4>
                                    {currentStop.points_open_ended !== undefined && (
                                        <Tag color="cyan">{currentStop.points_open_ended} Points</Tag>
                                    )}
                                </div>
                                <p className="corporate-text-secondary">{currentStop.quiz?.open_ended}</p>
                            </div>
                        </div>

                        <div className="accordion__grid">
                            <div className="accordion__section">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <h4 className="corporate-label" style={{ margin: 0 }}>Knowledge Check</h4>
                                        {currentStop.points_mc !== undefined && (
                                            <Tag color="orange">{currentStop.points_mc} Points</Tag>
                                        )}
                                    </div>
                                    <Button
                                        type="link"
                                        size="small"
                                        icon="reload"
                                        onClick={() => {
                                            Modal.confirm({
                                                title: 'Regenerate Quiz',
                                                content: 'Are you sure you want to regenerate the quiz for this stop?',
                                                okText: 'Regenerate',
                                                cancelText: 'Cancel',
                                                centered: true,
                                                onOk: () => handleRegenerateQuiz()
                                            })
                                        }}
                                        style={{ fontSize: '12px' }}
                                    >
                                        Regenerate
                                    </Button>
                                </div>
                                <div className="quiz-box">
                                    <div className="quiz-question">
                                        <Icon type="question-circle" style={{ color: '#1890ff', marginRight: 8 }} />
                                        {currentStop.quiz?.multiple_choice?.question}
                                    </div>
                                    <ul className="quiz-options">
                                        {/* {currentStop.quiz?.multiple_choice?.options?.map((opt, i) => (
                                            <li key={i}>
                                                {opt}
                                            </li>
                                        ))} */}
                                        {currentStop.quiz?.multiple_choice?.options?.map((opt, i) => (
                                            <li key={i} className={i === currentStop.quiz?.multiple_choice?.correct_index ? 'correct' : ''}>
                                                {i === currentStop.quiz?.multiple_choice?.correct_index && <Icon type="check-circle" theme="filled" />}
                                                {opt}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            {currentStop.clue && (
                                <div className="accordion__section">
                                    <h4 className="corporate-label">Mission Hints</h4>
                                    <div className="corporate-insight" style={{ marginBottom: 12 }}>
                                        <div style={{ fontSize: '13px', color: '#595959' }}>{currentStop.clue.narrative_content}</div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="accordion__location_grid">
                            {(currentStop.location || currentStop.clue) && (
                                <div className="accordion__section">
                                    <h4 className="corporate-label">Location Hints</h4>
                                    {currentStop.location && (
                                        <div className="corporate-insight" style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <Icon type="environment" style={{ color: '#1890ff', marginRight: 8, marginTop: 4 }} />
                                                <div>
                                                    <strong>{currentStop.location.name}</strong>
                                                    <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{currentStop.location.address}</div>
                                                </div>
                                            </div>
                                            <Button
                                                type="link"
                                                size="small"
                                                icon="edit"
                                                loading={isUpdating}
                                                onClick={() => setIsLocationModalVisible(true)}
                                            >
                                                Edit
                                            </Button>
                                        </div>
                                    )}
                                    <div className="corporate-hints">
                                        {currentStop.clue?.mission_context && (
                                            <div className="hint-item">
                                                <span className="hint-label">Mission:</span>
                                                <span className="hint-value">{currentStop.clue.mission_context}</span>
                                            </div>
                                        )}
                                        {currentStop.clue?.location_clues && (
                                            <div className="hint-item" style={{ flexDirection: 'column' }}>
                                                <span className="hint-label" style={{ width: '100%', marginBottom: 8 }}>Clues:</span>
                                                <div className="tag-group" style={{ display: 'block', marginLeft: 0 }}>
                                                    {currentStop.clue.location_clues.map((c, i) => (
                                                        <div key={i} className="corporate-text-secondary" style={{ marginBottom: 4, background: 'rgba(255,255,255,0.5)' }}>• {c}</div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                        {currentStop.clue?.confirmation && (
                                            <div className="hint-item" style={{ marginTop: 8 }}>
                                                <span className="hint-label">Find:</span>
                                                <span className="hint-value" style={{ color: '#52c41a', fontWeight: 600 }}>{currentStop.clue.confirmation}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* <div style={{ padding: '40px 0', textAlign: 'center' }}>
                    ...
                </div> */}

                <LocationPickerModal
                    open={isLocationModalVisible}
                    onClose={() => setIsLocationModalVisible(false)}
                    onLocationSelect={handleLocationSelect}
                    value={currentStop.location ? {
                        lat: parseFloat(currentStop.location.coordinates?.split(',')[0]),
                        lng: parseFloat(currentStop.location.coordinates?.split(',')[1]),
                        full: currentStop.location.address
                    } : null}
                />

                <Modal
                    title="Edit Content"
                    visible={editModalVisible}
                    onCancel={() => setEditModalVisible(false)}
                    footer={[
                        <Button
                            key="cancel"
                            onClick={() => setEditModalVisible(false)}
                            style={{ borderRadius: 50 }}
                        >
                            Cancel
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            loading={isSavingStop}
                            onClick={performUpdate}
                            disabled={!isEditDisabled}
                            style={{ borderRadius: 50 }}
                        >
                            Update
                        </Button>
                    ]}
                    centered
                    width={'50%'}
                >
                    <Form layout="vertical">
                        <Form.Item label="Mission Narrative">
                            <Input.TextArea
                                rows={6}
                                value={editFormData.story}
                                onChange={(e) => setEditFormData({ ...editFormData, story: e.target.value })}
                                placeholder="Enter the mission narrative/story..."
                            />
                        </Form.Item>
                        <Form.Item label="Mission Objective">
                            <Input.TextArea
                                rows={4}
                                value={editFormData.objective}
                                onChange={(e) => setEditFormData({ ...editFormData, objective: e.target.value })}
                                placeholder="Enter the mission objective..."
                            />
                        </Form.Item>
                        <Form.Item label="Fun Fact">
                            <Input.TextArea
                                rows={3}
                                value={editFormData.fun_fact}
                                onChange={(e) => setEditFormData({ ...editFormData, fun_fact: e.target.value })}
                                placeholder="Enter a fun fact..."
                            />
                        </Form.Item>
                        <Form.Item label="Open Ended Question">
                            <Input.TextArea
                                rows={3}
                                value={editFormData.open_ended}
                                onChange={(e) => setEditFormData({ ...editFormData, open_ended: e.target.value })}
                                placeholder="Enter the open ended question..."
                            />
                        </Form.Item>
                        <Row gutter={16}>
                            {(() => {
                                const isPointsMatching = isEditDisabled;
                                const validateStatus = isPointsMatching ? 'success' : 'error';
                                const helpText = isPointsMatching ? '' : 'Total must equal Quiz Points + OpenEnded Points';

                                return (
                                    <React.Fragment>
                                        <Col span={8}>
                                            <Form.Item
                                                label="Total Points"
                                            >
                                                <InputNumber
                                                    disabled
                                                    min={0}
                                                    style={{ width: '100%' }}
                                                    value={editFormData.points}
                                                    onChange={(val) => setEditFormData({ ...editFormData, points: val })}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                label="Quiz Points"
                                                validateStatus={validateStatus}
                                                hasFeedback
                                            >
                                                <InputNumber
                                                    min={0}
                                                    style={{ width: '100%' }}
                                                    value={editFormData.points_mc}
                                                    onChange={(val) => setEditFormData({ ...editFormData, points_mc: val })}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item
                                                label="Open Ended Points"
                                                validateStatus={validateStatus}
                                                hasFeedback
                                            >
                                                <InputNumber
                                                    min={0}
                                                    style={{ width: '100%' }}
                                                    value={editFormData.points_open_ended}
                                                    onChange={(val) => setEditFormData({ ...editFormData, points_open_ended: val })}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {helpText && <Col span={24}>
                                            <p style={{ color: 'red' }}>{helpText}</p>
                                        </Col>}

                                    </React.Fragment>
                                );
                            })()}
                        </Row>
                    </Form>
                </Modal>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    user: state.user,
})

export default connect(
    mapStateToProps,
)(ViewQuestStop)

